<template>
  <div>
    <v-row v-if="canAddOrSubmit">
      <v-col class="pl-0 align-left">
        <v-btn
          :disabled="!isEditable || isAddingOrEditing"
          :id="`btn_add_${id}`"
          variant="outlined"
          class="my-2 ml-1"
          @click="addCandidate"
          >Add</v-btn
        >
        <v-btn
          v-if="props.moduleType === MODULE_TYPES.MANAGEMENT"
          :disabled="!isEditable || isAddingOrEditing || isDirty"
          :id="`btn_add_${id}`"
          variant="outlined"
          class="my-2 ml-1"
          @click="submitToSAP"
          >Submit to SAP</v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          v-model:page="pageInspection.page"
          :items-per-page="pageInspection.itemsPerPage"
          class="noScrollTable table-headers_top"
          :items="localItems"
          :headers="computedHeaders"
          v-model:expanded="expanded"
          return-object
          must-sort
          v-model:sort-by="sortBy"
          @update:sort-by="maintenanceFooter.setPageValue(1)"
        >
          <template v-slot:[`header.data-table-expand`]="{ column }">
            {{ column.title }}
          </template>
          <template v-slot:[`header.agencyPriority`]="{ column }">
            <DataTableHeader :sortBy="sortBy" :column="column" />
          </template>
          <template v-slot:[`header.actCode`]="{ column }">
            <DataTableHeader :sortBy="sortBy" :column="column" />
          </template>
          <template v-slot:[`header.estimQuantity`]="{ column }" v-if="!isCompletedCandidates">
            <DataTableHeader :sortBy="sortBy" :column="column" />
          </template>
          <template v-slot:[`header.workRecDate`]="{ column }" v-if="!isCompletedCandidates">
            <DataTableHeader :sortBy="sortBy" :column="column" />
          </template>

          <template v-slot:[`header.completedDate`]="{ column }" v-if="isCompletedCandidates">
            <DataTableHeader :sortBy="sortBy" :column="column" />
          </template>
          <template v-slot:[`header.agencyStatus`]="{ column }">
            <DataTableHeader :sortBy="sortBy" :column="column" />
          </template>
          <template v-slot:[`header.location`]="{ column }" v-if="!isCompletedCandidates">
            <DataTableHeader :sortBy="sortBy" :column="column" />
          </template>

          <template v-slot:[`header.Action`]="{ column }" v-if="!isCompletedCandidates">
            <DataTableHeader :sortBy="sortBy" :column="column" />
          </template>
          <template v-slot:item="{ item }">
            <tr :class="rowClass(item)">
              <td class="text-center">
                <template v-if="expanded?.length == 0 || !isAddingOrEditing">
                  <button v-if="!expanded?.includes(item)" @click="toggleRow(item)">
                    <v-icon :id="`icon_Chevron_Right_${id}`" icon="fa-solid fa-chevron-right"></v-icon>
                  </button>

                  <button v-if="expanded?.includes(item)" @click="toggleRow(item)">
                    <v-icon :id="`icon_Chevron_Down_${id}`" icon="fa-solid fa-chevron-down"></v-icon>
                  </button>
                </template>
              </td>
              <td class="alignCenter">
                {{ item.agencyPriority }}
              </td>
              <td class="alignCenter" v-if="item.actKind == '1'">
                {{ configStore.getBridgeActionTitle(item.actCode) }}
              </td>
              <td class="alignCenter" v-else>
                {{ configStore.getFlexActionTitle(item.actCode) }}
              </td>
              <td class="alignCenter" v-if="!isCompletedCandidates">
                {{ item.estimQuantity }}
              </td>
              <td class="alignCenter" v-if="isCompletedCandidates">
                {{ getFormattedDateStringNoTime(item.completedDate) }}
              </td>
              <td v-else class="alignCenter">
                {{ getFormattedDateStringNoTime(item.workRecDate) }}
              </td>
              <td class="alignCenter">
                {{ configStore.getReferenceValue(REFERENCE_TABLE.AGENCY_STATUS, item.agencyStatus) }}
              </td>
              <td class="alignCenter" v-if="!isCompletedCandidates">
                {{ item.location }}
              </td>
              <td class="alignCenter">
                <div
                  style="white-space: nowrap"
                  v-if="
                    !item.readOnly && isEditable && (!isCompletedCandidates || moduleType == MODULE_TYPES.MANAGEMENT)
                  "
                >
                  <IconTooltip
                    :id="`icon_Update_${id}`"
                    icon="fa-solid fa-check"
                    :tooltip="item.isAdd ? 'Add' : 'Update'"
                    @click="saveEvent(item)"
                  />
                  <IconTooltip :id="`icon_Close_${id}`" icon="fa-solid fa-xmark" tooltip="Close" @click="close" />
                </div>
                <div
                  style="white-space: nowrap"
                  v-else-if="
                    isEditable &&
                    !isAddingOrEditing &&
                    (!isCompletedCandidates || moduleType == MODULE_TYPES.MANAGEMENT)
                  "
                >
                  <IconTooltip :id="`icon_Edit_${id}`" icon="fa-solid fa-pencil" tooltip="Edit" @click="edit(item)" />
                </div>
              </td>
            </tr>
          </template>
          <template v-slot:expanded-row="{ item }">
            <td :colspan="computedHeaders.length">
              <v-form v-model="valid" ref="modifyForm">
                <v-row class="pt-3 pl-6">
                  <v-col cols="12" lg="6" xl="6" class="pt-0 pb-1 pl-0 pr-0">
                    <LabelText
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="5"
                      textLg="5"
                      textMd="5"
                      textSm="5"
                      :id="`${id}_Candidate_ID`"
                      label="M.01 Candidate ID"
                      v-model="item.wcId"
                      type="text"
                    >
                    </LabelText>
                    <LabelSelect
                      :id="`${id}_Action`"
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      selectXl="5"
                      selectLg="5"
                      selectMd="5"
                      selectSm="5"
                      label="M.02 Action"
                      :isRequired="!item.readOnly && isEditable"
                      :options="getActionOptions(item.actKind)"
                      :isEditable="!item.readOnly && isEditable"
                      v-model="item.actCode"
                      @update:modelValue="changesDetected = true"
                    ></LabelSelect>
                    <LabelSelect
                      v-if="item.readOnly"
                      :id="`${id}_Status`"
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      selectXl="5"
                      selectLg="5"
                      selectMd="5"
                      selectSm="5"
                      label="M.03 Status"
                      :options="agencyStatus(item.agencyStatus)"
                      v-model="item.agencyStatus"
                    ></LabelSelect>
                    <LabelSelect
                      v-else
                      :id="`${id}_Status`"
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      selectXl="5"
                      selectLg="5"
                      selectMd="5"
                      selectSm="5"
                      label="M.03 Status"
                      :isRequired="!item.readOnly && isEditable"
                      :options="agencyStatus(item.agencyStatus)"
                      :isEditable="!item.readOnly && isEditable"
                      v-model="setStatus"
                      @update:modelValue="updateStatusDependencies(item)"
                    ></LabelSelect>
                    <LabelText
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="5"
                      textLg="5"
                      textMd="5"
                      textSm="5"
                      :id="`${id}_Estimated_Quantity`"
                      label="M.04 Estimated Quantity"
                      :allowCommas="false"
                      :showMax="false"
                      :min="1"
                      :maxlength="7"
                      v-model="item.estimQuantity"
                      :appendWith="getUOM(item)"
                      :isRequired="!item.readOnly && isEditable"
                      :isEditable="!item.readOnly && isEditable"
                      type="number"
                      @update:modelValue="changesDetected = true"
                    >
                    </LabelText>
                    <LabelSelect
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      selectXl="5"
                      selectLg="5"
                      selectMd="5"
                      selectSm="5"
                      showDurationIcon
                      :tooltip="'Priority Change History'"
                      :id="`${id}_Priority`"
                      :isRequired="!item.readOnly && isEditable"
                      label="M.05 Priority"
                      :refTable="REFERENCE_TABLE.AGENCY_PRIORITY"
                      :isEditable="!item.readOnly && isEditable"
                      v-model="item.agencyPriority"
                      @show-history="forwardChangeHistory(id, item.wcId)"
                      @update:modelValue="
                        validateForm();
                        changesDetected = true;
                      "
                    ></LabelSelect>
                    <LabelDatefield
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="5"
                      textLg="5"
                      textMd="5"
                      textSm="5"
                      :id="`${id}_PriorityChangeDate`"
                      label="M.06 Date Maint Pri Changed"
                      v-if="moduleType === MODULE_TYPES.MANAGEMENT"
                      v-model="item.priorityChangeDate"
                      :showTime="true"
                      @update:modelValue="changesDetected = true"
                    >
                    </LabelDatefield>
                    <LabelDatefield
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="5"
                      textLg="5"
                      textMd="5"
                      textSm="5"
                      label="M.07 Initial Recommended Date"
                      :id="`${id}_Edit_Recommended_Date`"
                      v-model="item.workRecDate"
                      :isEditable="!item.readOnly && isEditable"
                      :isRequired="!item.readOnly && isEditable && !isCompletedCandidates"
                      @update:modelValue="changesDetected = true"
                    >
                    </LabelDatefield>
                    <LabelDatefield
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="5"
                      textLg="5"
                      textMd="5"
                      textSm="5"
                      v-if="moduleType === MODULE_TYPES.MANAGEMENT && isCompletedCandidates"
                      label="M.23 SAP Closed Date"
                      :id="`${id}_SAP_Closed_Date`"
                      v-model="item.schedCloseDate"
                    >
                    </LabelDatefield>
                    <LabelText
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="5"
                      textLg="5"
                      textMd="5"
                      textSm="5"
                      v-if="moduleType === MODULE_TYPES.MANAGEMENT && isCompletedCandidates"
                      :id="`${id}_SAP_WO_Number`"
                      label="M.24 SAP WO Number"
                      v-model="item.sapWorkOrderNum"
                    >
                    </LabelText>
                    <LabelText
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="5"
                      textLg="5"
                      textMd="5"
                      textSm="5"
                      :id="`${id}_Actual_Quantity`"
                      label="M.25 Actual Quantity"
                      v-if="moduleType === MODULE_TYPES.MANAGEMENT && isCompletedCandidates"
                      v-model="item.quantity"
                    >
                    </LabelText>
                    <LabelText
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="5"
                      textLg="5"
                      textMd="5"
                      textSm="5"
                      :id="`${id}_Actual_Cost`"
                      label="M.26 Actual Cost"
                      v-if="moduleType === MODULE_TYPES.MANAGEMENT && isCompletedCandidates"
                      v-model="item.estimCost"
                    >
                    </LabelText>
                    <LabelText
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="5"
                      textLg="5"
                      textMd="5"
                      textSm="5"
                      :id="`${id}_MPMS`"
                      label="M.27 MPMS#"
                      v-if="moduleType === MODULE_TYPES.MANAGEMENT && isCompletedCandidates"
                      v-model="item.mpmsProjectNum"
                    >
                    </LabelText>
                  </v-col>
                  <v-col cols="12" lg="6" xl="6" class="pt-0 pl-0 pb-1 pr-0">
                    <LabelText
                      :id="`${id}_Scope`"
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="5"
                      textLg="5"
                      textMd="5"
                      textSm="5"
                      label="M.08 Scope"
                      :refTable="REFERENCE_TABLE.ACTION_SCOPE"
                      v-model="item.actKind"
                    ></LabelText>
                    <LabelSelect
                      :id="`${id}_Structure_Unit`"
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      selectXl="5"
                      selectLg="5"
                      selectMd="5"
                      selectSm="5"
                      label="M.09 Structure Unit"
                      :options="structureUnitList"
                      :isEditable="!item.readOnly && isEditable"
                      v-model="item.strUnitKey"
                      @update:modelValue="changesDetected = true"
                    ></LabelSelect>
                    <LabelText
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="5"
                      textLg="5"
                      textMd="5"
                      textSm="5"
                      :id="`${id}_Target_Year`"
                      label="M.10 Target Year"
                      v-model="item.targetYear"
                      :isEditable="!item.readOnly && isEditable"
                      :rules="[(val) => targetYearRules[0](val, setStatus)]"
                      :isRequired="targetYearRequired(setStatus) && !item.readOnly && isEditable"
                      type="number"
                      :showComma="false"
                      :maxlength="4"
                      @update:modelValue="changesDetected = true"
                    >
                    </LabelText>
                    <LabelSelect
                      :id="`${id}_Work_Assign`"
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      selectXl="5"
                      selectLg="5"
                      selectMd="5"
                      selectSm="5"
                      label="M.11 Work Assign"
                      :refTable="REFERENCE_TABLE.WORK_ASSIGNMENT"
                      :isEditable="!item.readOnly && isEditable && setStatus != '1' && setStatus != '2'"
                      v-model="item.workAssignment"
                      @update:modelValue="changesDetected = true"
                    ></LabelSelect>
                    <LabelSelect
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      selectXl="5"
                      selectLg="5"
                      selectMd="5"
                      selectSm="5"
                      :id="`${id}_Drawing`"
                      label="M.12 Drawing"
                      v-if="moduleType === MODULE_TYPES.MANAGEMENT"
                      :refTable="REFERENCE_TABLE.YES_NO"
                      :isEditable="!item.readOnly && isEditable"
                      v-model="item.drawingInd"
                      @update:modelValue="
                        validateForm();
                        changesDetected = true;
                      "
                    ></LabelSelect>
                    <LabelSelect
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      selectXl="5"
                      selectLg="5"
                      selectMd="5"
                      selectSm="5"
                      :id="`${id}_Permit`"
                      label="M.13 Permit"
                      v-if="moduleType === MODULE_TYPES.MANAGEMENT"
                      :refTable="REFERENCE_TABLE.YES_NO"
                      :isEditable="!item.readOnly && isEditable"
                      v-model="item.permitInd"
                      @update:modelValue="
                        validateForm();
                        changesDetected = true;
                      "
                    ></LabelSelect>
                    <LabelDatefield
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="5"
                      textLg="5"
                      textMd="5"
                      textSm="5"
                      v-if="moduleType === MODULE_TYPES.MANAGEMENT"
                      label="M.14 POA Date"
                      :id="`${id}_POA_Date`"
                      v-model="item.poaDate"
                      :isEditable="!item.readOnly && isEditable"
                      :isRequired="
                        !item.readOnly &&
                        isEditable &&
                        item.actKind == '3' &&
                        (item.agencyPriority == '1' || item.agencyPriority == '0')
                      "
                      @update:modelValue="changesDetected = true"
                    >
                    </LabelDatefield>
                    <LabelDatefield
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="5"
                      textLg="5"
                      textMd="5"
                      textSm="5"
                      v-if="moduleType === MODULE_TYPES.MANAGEMENT"
                      label="M.15 Mitigation Date"
                      :id="`${id}_Mitigation_Date`"
                      v-model="item.mitigationDate"
                      :isEditable="!item.readOnly && isEditable"
                      @update:modelValue="changesDetected = true"
                    >
                    </LabelDatefield>
                    <LabelDatefield
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="5"
                      textLg="5"
                      textMd="5"
                      textSm="5"
                      v-if="moduleType === MODULE_TYPES.MANAGEMENT"
                      label="M.16 Completed Date"
                      :id="`${id}_Completed_Date`"
                      :minDate="new Date('01/02/1901')"
                      v-model="item.completedDate"
                      :isEditable="
                        !item.readOnly && isEditable && (setStatus == '5' || setStatus == '6' || setStatus == '7')
                      "
                      :maxDate="new Date()"
                      :isRequired="
                        (setStatus == '5' || setStatus == '6' || setStatus == '7') && !item.readOnly && isEditable
                      "
                      @update:modelValue="changesDetected = true"
                    >
                    </LabelDatefield>
                    <LabelDatefield
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="5"
                      textLg="5"
                      textMd="5"
                      textSm="5"
                      label="M.16 Completed Date"
                      :minDate="new Date('01/02/1901')"
                      :id="`${id}_Completed_Date`"
                      v-model="item.completedDate"
                      v-if="moduleType === MODULE_TYPES.INSPECTION"
                      :isEditable="
                        (setStatus == '5' || setStatus == '6' || setStatus == '7') && !item.readOnly && isEditable
                      "
                      :maxDate="new Date()"
                      :isRequired="
                        (setStatus == '5' || setStatus == '6' || setStatus == '7') && !item.readOnly && isEditable
                      "
                      @update:modelValue="changesDetected = true"
                    >
                    </LabelDatefield>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pl-6 pb-0 pr-2 pt-1">
                    <LabelText
                      :labelXl="12"
                      :labelLg="12"
                      :labelMd="12"
                      :labelSm="12"
                      :textXl="12"
                      :textLg="12"
                      :textMd="12"
                      :textSm="12"
                      :id="`${id}_Location`"
                      v-model="item.location"
                      :isEditable="!item.readOnly && isEditable"
                      :counter="locationMaxLength"
                      :maxlength="locationMaxLength"
                      label="M.17 Location"
                      persistent-counter
                      type="textarea"
                      auto-grow
                      rows="1"
                      @update:modelValue="changesDetected = true"
                    >
                    </LabelText>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pt-0 pl-6 pb-4 pr-2">
                    <LabelText
                      class="pt-0"
                      :labelXl="12"
                      :labelLg="12"
                      :labelMd="12"
                      :labelSm="12"
                      :textXl="12"
                      :textLg="12"
                      :textMd="12"
                      :textSm="12"
                      :id="`${id}_Work_Candidate_Notes`"
                      v-model="item.notes"
                      :isEditable="!item.readOnly && isEditable"
                      :counter="commentsMaxLength"
                      :maxlength="commentsMaxLength"
                      label="M.18 Work Candidate Notes"
                      :isRequired="
                        !item.readOnly && isEditable && (item.agencyPriority == '0' || item.agencyPriority == '1')
                      "
                      persistent-counter
                      type="textarea"
                      auto-grow
                      @update:modelValue="changesDetected = true"
                    >
                    </LabelText>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    class="pt-0 pl-6 pb-4 pr-2"
                    v-if="!isCompletedCandidates && moduleType === MODULE_TYPES.MANAGEMENT"
                  >
                    <LabelText
                      class="pt-0"
                      :labelXl="12"
                      :labelLg="12"
                      :labelMd="12"
                      :labelSm="12"
                      :textXl="12"
                      :textLg="12"
                      :textMd="12"
                      :textSm="12"
                      :id="`${id}_Work_Candidate_deferred_Notes`"
                      v-model="item.deferredActionDesc"
                      :isEditable="!item.readOnly && isEditable"
                      :isRequired="
                        !item.readOnly && isEditable && Number.parseInt(item.agencyPriority) >= 1 && setStatus == 'D'
                      "
                      :counter="commentsMaxLength"
                      :maxlength="commentsMaxLength"
                      label="M.19 Deferred Notes"
                      persistent-counter
                      type="textarea"
                      auto-grow
                      @update:modelValue="changesDetected = true"
                    >
                    </LabelText>
                  </v-col>
                </v-row>
                <v-row class="pl-6" v-if="moduleType === MODULE_TYPES.MANAGEMENT">
                  <v-col cols="12" lg="6" xl="6" class="pt-0 pb-1 pr-0">
                    <LabelText
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="6"
                      textLg="6"
                      textMd="6"
                      textSm="6"
                      :id="`${id}_Bridge_Appr`"
                      label="M.20 Bridge Appr"
                      maxlength="40"
                      :isEditable="!item.readOnly && isEditable"
                      v-model="item.bridgeApproval"
                      @update:modelValue="changesDetected = true"
                    >
                    </LabelText>
                  </v-col>
                  <v-col cols="12" lg="6" xl="6" class="pt-0 pb-1 pr-0"> </v-col>
                </v-row>
                <v-row class="pl-6" v-if="moduleType === MODULE_TYPES.MANAGEMENT">
                  <v-col cols="12" lg="6" xl="6" class="pt-0 pb-1 pr-0">
                    <LabelText
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="6"
                      textLg="6"
                      textMd="6"
                      textSm="6"
                      :id="`${id}_Maint_Appr`"
                      label="M.21  Maint Appr"
                      maxlength="40"
                      :isEditable="!item.readOnly && isEditable"
                      v-model="item.maintApproval"
                      @update:modelValue="changesDetected = true"
                    >
                    </LabelText>
                  </v-col>
                  <v-col cols="12" lg="6" xl="6" class="pt-0 pb-1 pr-0"> </v-col>
                </v-row>
                <v-row class="pl-6 pb-6" v-if="moduleType === MODULE_TYPES.MANAGEMENT">
                  <v-col cols="12" lg="6" xl="6" class="pt-0 pb-1 pr-0">
                    <LabelText
                      labelXl="6"
                      labelLg="6"
                      labelMd="6"
                      labelSm="6"
                      textXl="4"
                      textLg="4"
                      textMd="5"
                      textSm="5"
                      :id="`${id}_MAPI_Plan_Year`"
                      label="M.22 MAPI Plan Year"
                      :isEditable="!item.readOnly && isEditable"
                      v-model="item.coApproval"
                      :showComma="showComma"
                      :maxlength="4"
                      type="number"
                      @update:modelValue="changesDetected = true"
                    >
                    </LabelText>
                  </v-col>
                  <v-col cols="12" lg="6" xl="6" class="pt-0 pb-1 pr-0"> </v-col>
                </v-row>
              </v-form>
              <div style="margin: 0 24px 24px">
                <div class="customHeader">Workflow</div>
                <v-data-table
                  :headers="MaintenanceWorkflowTableHeader"
                  :items="item.inspectionWCANDAudits"
                  :items-per-page="-1"
                  hide-default-footer
                >
                  <template v-slot:[`header.columnName`]="{ column }">
                    <DataTableHeader :column="column" :lines="2" />
                  </template>
                  <template v-slot:[`header.updateUserId`]="{ column }">
                    <DataTableHeader :column="column" :lines="2" />
                  </template>
                  <template v-slot:[`header.updateDateTime`]="{ column }">
                    <DataTableHeader :column="column" :lines="2" />
                  </template>
                  <template v-slot:item="{ item }">
                    <tr style="word-break: break-word">
                      <td class="alignCenter">
                        {{ getColumnName(item.columnName) }}
                      </td>
                      <td class="alignCenter">
                        {{ configStore.getUserNameByUserLogin(item.updateUserId) }}
                      </td>

                      <td class="alignCenter">
                        {{ formatDateTime12Hour(new Date(item.updateDateTime)) }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </td>
          </template>
          <template v-slot:bottom>
            <DataTableFooter
              ref="maintenanceFooter"
              id="inspection_maintenance_footer"
              :items="localItems"
              v-model="pageInspection"
            ></DataTableFooter>
          </template>
        </v-data-table> </v-col
    ></v-row>
    <ConfirmDialog ref="closeConfirm" :cancelButtonText="BUTTONS.NO" />
  </div>
</template>
<script setup>
import { computed, ref, nextTick } from "vue";
import LabelDatefield from "@/components/common/LabelDatefield.vue";
import LabelSelect from "@/components/common/LabelSelect.vue";
import IconTooltip from "@/components/common/IconTooltip.vue";
import LabelText from "@/components/common/LabelText.vue";
import { useConfigStore } from "@/stores/config";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { ENV_CONFIG_PROPERTY } from "@/constants/EnvConfigProperties";
import { useInspectionStore } from "@/stores/inspection";
import { BUTTONS } from "@/constants/CommonWebConstants";
import { INSPECTION_MESSAGES, MODULE_TYPES } from "@/constants/InspectionConstants";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { clone } from "@/util/clone";
import maintenanceCandidate from "@/data/maintenanceCandidate";
import DataTableHeader from "@/components/common/DataTableHeader.vue";
import DataTableFooter from "@/components/common/DataTableFooter.vue";
import { getFormattedDateStringNoTime, formatDateTime12Hour } from "@/composables/dateField.js";
import { useInventoryStore } from "@/stores/inventory";
import { CWOPA_ROLES } from "@/rbac/roles.js";
import { useUserStore } from "@/stores/userStore";
import { MaintenanceWorkflowTableHeader } from "@/constants/WorkflowTable";

const props = defineProps({
  id: { default: "" },
  items: {
    default: [],
  },
  isCompletedCandidates: {
    default: false,
    type: Boolean,
  },
  isEditable: { default: false, type: Boolean },
  canAddOrSubmit: { default: false, type: Boolean },
  brkey: { type: Number },
  servTypOn: { type: String },
  structureUnits: { default: [] },
  moduleType: { default: MODULE_TYPES.INSPECTION },
});
const emits = defineEmits([
  "save",
  "showMessage",
  "hideMessage",
  "show-change-history-dialog",
  "submit-Maintenance-Items-To-SAP",
]);
let expanded = ref([]);
const closeConfirm = ref(null);
const inspectionStore = useInspectionStore();

const inventoryStore = useInventoryStore();
const userStore = useUserStore();
const userRoles = computed(() => userStore.getUserRoles());
const setAddingOrEditing = (value) => {
  if (props.moduleType === MODULE_TYPES.INSPECTION) {
    inspectionStore.setAddingOrEditing(value);
  } else {
    inventoryStore.isAddingOrEditingMaintenanceTable = value;
  }
};
const computedHeaders = computed(() => {
  if (props.isCompletedCandidates) {
    return completedHeaders;
  } else {
    return proposedHeaders;
  }
});
const getColumnName = (columnName) => {
  switch (columnName) {
    case "POADate":
      return "M.14 POA Date";
    case "BridgeApproval":
      return "M.20 Bridge Appr";
    case "MaintApproval":
      return "M.21 Maint Appr";
    default:
      return name;
  }
};
const sortBy = ref([{ key: "agencyPriority", order: "asc" }]);
let previousSort = ref([{ key: "agencyPriority", order: "asc" }]);
const completedHeaders = [
  {
    key: "data-table-expand",
  },
  {
    line1: "M.05",
    line2: "Priority",
    line3: null,
    sortable: true,
    key: "agencyPriority",
  },
  {
    line1: "M.02",
    line2: "Action",
    line3: null,
    sortable: true,
    key: "actCode",
  },
  {
    line1: "M.16",
    line2: "Completed",
    line3: "Date",
    sortable: true,
    key: "completedDate",
  },
  {
    line1: "M.03",
    line2: "Status",
    line3: null,
    sortable: true,
    key: "agencyStatus",
  },
  {
    line1: null,
    line2: "Action",
    line3: null,
    sortable: false,
    key: "Action",
  },
];

const proposedHeaders = [
  {
    key: "data-table-expand",
  },
  {
    line1: "M.05",
    line2: "Priority",
    line3: null,
    sortable: true,
    key: "agencyPriority",
  },
  {
    line1: "M.02",
    line2: "Action",
    line3: null,
    sortable: true,
    key: "actCode",
  },
  {
    line1: "M.04",
    line2: "Est",
    line3: "Qty",
    sortable: false,
    key: "estimQuantity",
  },
  {
    line1: "M.07",
    line2: "Initial",
    line3: "Recm'd Date",
    sortable: true,
    key: "workRecDate",
  },
  {
    line1: "M.03",
    line2: "Status",
    line3: null,
    sortable: true,
    key: "agencyStatus",
  },
  {
    line1: "M.17",
    line2: "Location",
    line3: null,
    sortable: true,
    key: "location",
    width: "20%",
  },
  {
    line1: null,
    line2: "Action",
    line3: null,
    sortable: false,
    key: "Action",
  },
];

let isDirty = computed({
  get() {
    if (props.moduleType === MODULE_TYPES.INSPECTION) {
      inspectionStore.getDirtyFlag();
      return;
    }
    return inventoryStore.getIsDirty();
  },
});

const computedMessage = computed(() => {
  if (props.isCompletedCandidates) {
    //message for completed candidates
    return INSPECTION_MESSAGES.MAINTENANCE_COMPLETED_SAVE_MESSAGE;
  } else {
    return INSPECTION_MESSAGES.MAINTENANCE_PROPOSED_SAVE_MESSAGE;
  }
});

const rowClass = (detail) => {
  if (expanded.value.includes(detail)) {
    return "rowSelect";
  } else if (detail.refWItemKey != null && ["1", "3"].includes(detail.agencyStatus)) {
    return "rowHighlight";
  } else {
    return "rowUnselect";
  }
};

let validationSnackbar = computed({
  get() {
    if (props.moduleType === MODULE_TYPES.INSPECTION) {
      return inspectionStore.getShowValidationSnackbar;
    } else {
      return inventoryStore.showValidationSnackbar;
    }
  },
  set(value) {
    if (props.moduleType === MODULE_TYPES.INSPECTION) {
      inspectionStore.setShowValidationSnackbar(value);
    } else {
      inventoryStore.showValidationSnackbar = value;
    }
  },
});

const toggleRow = (detail) => {
  if (expanded.value.includes(detail)) {
    const index = expanded.value.findIndex((d) => d == detail);
    expanded.value.splice(index, 1);
  } else {
    expanded.value.push(detail);
  }
};

const isAddingOrEditing = computed(() => {
  if (props.moduleType === MODULE_TYPES.INSPECTION) {
    return inspectionStore.getAddingOrEditing;
  } else {
    return inventoryStore.isAddingOrEditingMaintenanceTable;
  }
});

const configStore = useConfigStore();
let modifyForm = ref(null);

const getActionOptions = (scope) => {
  if (scope && scope == "1") {
    return configStore.getBridgeActions;
  } else {
    return configStore.getFlexActions(props.servTypOn);
  }
};

const getUOM = (item) => {
  if (item.actKind !== "1" && item.actCode) {
    return ` ${configStore.getFlexAction(item.actCode)?.uom}`;
  }
  return "";
};

const commentsMaxLength = computed(() => {
  return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.INSPECTION_COMMENT_MAX_LENGTH);
});

const locationMaxLength = computed(() => {
  return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.ELEM_DESC_MAX_LENGTH);
});

const agencyStatus = (status) => {
  let options = [];
  let isPowerOrSuperUser =
    userRoles.value.includes(CWOPA_ROLES.BMS_SUPERUSER) || userRoles.value.includes(CWOPA_ROLES.BMS_POWERUSER);
  // If status is D return 1, 2, 5, 6, 7, and D  
  if (["D"].includes(status)) {
    options = configStore
      .getReferenceValues(REFERENCE_TABLE.AGENCY_STATUS)
      ?.filter((a) => ["1", "2", "5", "6", "7", "D"].includes(a.value));
  }
  // If status is 5, 6, 7 return only those values and D
  else if (["5", "6", "7"].includes(status)) {
    options = configStore
      .getReferenceValues(REFERENCE_TABLE.AGENCY_STATUS)
      ?.filter((a) => ["5", "6", "7", "D"].includes(a.value));
  }
  // If status is 3 (submitted to SAP), it should not be modifiable for anyone but Super/Power users
  else if (["3"].includes(status)) {
    if (isPowerOrSuperUser) {
      options = configStore.getReferenceValues(REFERENCE_TABLE.AGENCY_STATUS);
    } else {
      options = configStore.getReferenceValues(REFERENCE_TABLE.AGENCY_STATUS)?.filter((a) => a.value == "3");
    }
  }
  // If status is not 3 or 5->7 & D, all options are available (except 3)
  else {
    options = configStore.getReferenceValues(REFERENCE_TABLE.AGENCY_STATUS)?.filter((a) => a.value != "3");
  }
  return options;
};

const structureUnitList = computed(() => {
  let structures = [];

  structures.push({ value: -1, title: "All Units" });

  for (const unit of props.structureUnits ?? []) {
    structures.push({
      value: unit.strUnitKey,
      title: unit.legacyStructureType + " - " + unit.strUnitLabel,
    });
  }

  return structures;
});

let valid = ref(false);
let changesDetected = ref(false);
let setStatus = ref(null);
let localItems = ref(clone(props.items));
let maintenanceFooter = ref(null);
let showComma = ref(false);
const pageInspection = ref({
  itemsPerPage: 30,
  page: 1,
});

const targetYearRequired = (agencyStatus) => {
  return ["1", "2"].includes(agencyStatus);
};

const targetYearRules = [
  (yearData, agencyStatus) => {
    if (!targetYearRequired(agencyStatus)) {
      return true;
    }
    if (props.moduleType === MODULE_TYPES.INSPECTION) {
      return true;
    }
    const year = +yearData;
    if (2009 <= year && year <= 2069) {
      return true;
    }
    return "Valid range 2009 - 2069";
  },
];
const resetItems = () => {
  expanded.value = [];
  localItems.value = clone(props.items);
};

const close = () => {
  if (props.isEditable && changesDetected.value) {
    //show confirmation dialog on closing
    closeConfirm.value
      .open(INSPECTION_MESSAGES.DETECT_DATATABLE_CHANGE_CONFIRMATION_MESSAGE, BUTTONS.YES)
      .then((response) => {
        if (!response) {
          hideMessageEvent();
          changesDetected.value = false;
          expanded.value = [];
          resetItems();
          sortBy.value = previousSort.value?.map((x) => x);
          setAddingOrEditing(false);
        }
      });
  } else {
    sortBy.value = previousSort.value?.map((x) => x);
    hideMessageEvent();
    expanded.value = [];
    resetItems();
    setAddingOrEditing(false);
  }
};
const edit = (detail) => {
  showMessageEvent();
  setAddingOrEditing(true);
  detail.readOnly = false;
  setStatus.value = detail.agencyStatus;
  nextTick(() => {
    modifyForm.value?.validate();
  });
  previousSort.value = sortBy.value.map((x) => x);
  sortBy.value = [];
  moveEditableElementToTop(detail);
};

const moveEditableElementToTop = (detail) => {
  const index = localItems.value.findIndex((d) => d.uniqueKey === detail.uniqueKey);
  if (index === -1) return;
  let editableElement = localItems.value[index];
  localItems.value.splice(index, 1);
  const page = pageInspection.value.page;
  const pageSize = pageInspection.value.itemsPerPage;
  //calculate the top index of current page
  const pageStartIndex = (page - 1) * pageSize;
  //Insert edited item at top pf the current page
  localItems.value.splice(pageStartIndex, 0, editableElement);
  expanded.value.push(editableElement);
};

const getNewCandidate = () => {
  let candidate = clone(maintenanceCandidate);
  candidate.brkey = props.brkey;
  candidate.updateDateTime = new Date().toISOString();
  candidate.updateUserId = "BMS3";
  candidate.wcKey = candidate.wcId = generateWCID();
  candidate.actKind = "3";
  candidate.objKind = "0";
  candidate.objCode = "0";
  return candidate;
};

const addCandidate = () => {
  showMessageEvent();
  let candidate = getNewCandidate();
  setStatus.value = null;
  candidate.isAdd = true;
  previousSort.value = sortBy.value.map((x) => x);
  sortBy.value = [];
  expanded.value.push(candidate);
  localItems.value.unshift(candidate);
  changesDetected.value = false;
  setAddingOrEditing(true);
  nextTick(() => {
    modifyForm.value?.validate();
  });
};

const forwardChangeHistory = (id, wcId) => {
  emits("show-change-history-dialog", { id, wcId });
};

const generateWCID = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  const hours = `${date.getHours()}`.padStart(2, "0");
  const minutes = `${date.getMinutes()}`.padStart(2, "0");
  const seconds = `${date.getSeconds()}`.padStart(2, "0");
  const milliseconds = ("00" + date.getMilliseconds()).slice(-3);
  const paddedValue = String(props.brkey).padStart(6, "0");
  const output = `BMS3-${paddedValue}-${year}-${month}${day}-${hours}${minutes}${seconds}${milliseconds}`;
  return output.slice(0, 30);
};

const saveEvent = (detail) => {
  modifyForm.value?.validate().then(() => {
    if (valid.value) {
      validationSnackbar.value = false;
      setAddingOrEditing(false);
      changesDetected.value = false;
      detail.agencyStatus = setStatus.value;
      setStatus.value = null;
      emits("save", detail);
      hideMessageEvent();
      sortBy.value = previousSort.value?.map((x) => x);
    } else {
      validationSnackbar.value = true;
    }
  });
};

const validateForm = () => {
  modifyForm.value?.validate();
};

const checkFormValidation = () => {
  nextTick(() => {
    modifyForm.value?.validate();
  });
};

const showMessageEvent = () => {
  emits("showMessage", computedMessage.value);
};
const hideMessageEvent = () => {
  emits("hideMessage");
};

const submitToSAP = () => {
  emits("submit-Maintenance-Items-To-SAP");
};

const updateStatusDependencies = (detail) => {
  changesDetected.value = true;
  detail.completedDate = null;
  if (setStatus.value == "1") {
    detail.workAssignment = "0";
  } else if (setStatus.value == "2") {
    detail.workAssignment = "1";
  }
  checkFormValidation();
};
defineExpose({
  resetItems,
});
</script>
<style scoped lang="scss">
@use "@/styles/colors" as c;

.v-expansion-panel-title,
.v-expansion-panel-title:hover {
  background-color: c.$p-pa-light-blue !important;
}

.rowHighlight,
.rowHighlight:hover {
  background-color: c.$e-yellow !important;

  td {
    background-color: c.$e-yellow !important;
  }
}

h3 {
  order: 1;
  color: c.$p-white !important;
}
.v-expansion-panel-title__icon {
  order: 0;
}
.alignCenter {
  text-align: center;
}
.v-data-table :deep(button:hover) {
  background-color: inherit !important;
  color: inherit !important;
}

.v-data-table :deep(button:focus) {
  outline: none !important;
}
.tableHeader {
  text-align: center !important;
  background: c.$p-pa-light-blue !important;
}
.customHeader {
  padding: 10px !important;
  font-weight: 700 !important;
  font-size: 15px !important;
  color: #ffffff !important;
  background: #464646 !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
